import * as React from 'react';

import { TextLabel, Button } from '@wix/wix-base-ui';

import styles from './FeedError.scss';

interface FeedErrorProps {
  onFetchClick(): void;
}

const FeedError: React.FunctionComponent<FeedErrorProps> = (props) => (
  <div className={styles.container}>
    <TextLabel
      type="T03"
      value="Oops, something went wrong"
      enableEllipsis={false}
      shouldTranslate={false}
    />
    <br />
    <Button onClick={props.onFetchClick}>Try again</Button>
  </div>
);

FeedError.displayName = 'FeedError';

export default FeedError;
